import { PluginSlot } from '@openedx/frontend-plugin-framework';
import React from 'react';

const CourseOutlinePageAlertsSlot = () => <PluginSlot id="org.openedx.frontend.authoring.course_outline_page_alerts.v1" />;
export default CourseOutlinePageAlertsSlot;
